import { render, staticRenderFns } from "./client-level-setting.vue?vue&type=template&id=73f24d48&"
import script from "./client-level-setting.vue?vue&type=script&lang=js&"
export * from "./client-level-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports